import styled from 'styled-components';

export const MSLHeadTable = styled.div`
  width: 100%;
  height: 60vh;
`;

export const TooltipContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const TooltipIconWrapper = styled.div`
  cursor: pointer;
  font-size: 16px;
  margin-top: 5px;

  .motif-icon,
  svg {
    color: #4682b4 !important;
    fill: #4682b4 !important;
  }
`;

export const TooltipContent = styled.div`
  white-space: pre-line;
  font-family: EYInterstate;
`;

export const TooltipStyle = {
  backgroundColor: '#add8e6',
  color: '#000000',
  maxWidth: '300px',
  fontSize: '12px',
  borderRadius: '4px',
  fontFamily: 'EYInterstate',
};

// Dark themed tooltip styles for past table
export const TooltipIconWrapperDark = styled.div`
  cursor: pointer;
  font-size: 16px;
  margin-top: 5px;

  .motif-icon,
  svg {
    color: #e6e6e6 !important;
    fill: #e6e6e6 !important;
  }
`;
